module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "coverages-fade",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "panel-wrapper"
  }, [_c('div', {
    staticClass: "panel-content"
  }, [_c('div', {
    staticClass: "mast-head"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.addCoverageLabel)
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "accordion"
  }, [(_vm.hasServiceLineCoverages) ? _c('li', {
    attrs: {
      "data-type": "service-line"
    }
  }, [_c('a', {
    attrs: {
      "id": "anchor_service-line",
      "name": "anchor_service-line"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-heading",
    attrs: {
      "for": "tab-service-line"
    }
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceLineLabel)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.serviceLineLeadIn) ? _c('div', {
    staticClass: "lead-in service-line",
    domProps: {
      "innerHTML": _vm._s(_vm.serviceLineLeadIn)
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "coverage-links"
  }, _vm._l((_vm.serviceLineCoverages), function(coverage) {
    return _c('li', [_c('a', {
      domProps: {
        "innerHTML": _vm._s(coverage.exposure_label)
      },
      on: {
        "click": function($event) {
          _vm.togglePanel('panel-content-exposure', coverage.exposure_slug, $event, true, false)
        }
      }
    })])
  }))]), _vm._v(" "), (_vm.hasOffPremiseCoverages) ? _c('hr') : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.hasOffPremiseCoverages) ? _c('li', {
    attrs: {
      "data-type": "off-premise"
    }
  }, [_c('a', {
    attrs: {
      "id": "anchor_off-premise",
      "name": "anchor_off-premise"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-heading",
    attrs: {
      "for": "tab-off-premise"
    }
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.offPremiseLabel)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.offPremiseLeadIn) ? _c('div', {
    staticClass: "lead-in",
    domProps: {
      "innerHTML": _vm._s(_vm.offPremiseLeadIn)
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "coverage-links"
  }, _vm._l((_vm.offPremiseCoverages), function(coverage) {
    return _c('li', [_c('a', {
      domProps: {
        "innerHTML": _vm._s(coverage.exposure_label)
      },
      on: {
        "click": function($event) {
          _vm.togglePanel('panel-content-exposure', coverage.exposure_slug, $event, false, true)
        }
      }
    })])
  }))])]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d302640","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileContentCoverages.vue
// module id = 458
// module chunks = 1